import countries from '../baseDatasets/countries.json';

const sortedCountries = Object.entries(countries).sort(([,a],[,b]) => (a > b) - (a < b));

export default sortedCountries;
